import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		}
	},
	fonts: {
		heading: "'Vazirmatn', sans-serif",
		body: "'Vazirmatn', sans-serif",
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode('gray.50', 'gray.800')(props),
				fontFamily: "'Vazirmatn', sans-serif",
				direction: 'rtl',
				textAlign: 'right'
			},
			html: {
				fontFamily: "'Vazirmatn', sans-serif",
				direction: 'rtl',
				textAlign: 'right'
			},
			'*': {
				direction: 'rtl'
			},
			'h1, h2, h3, h4, h5, h6': {
				fontFamily: "'Vazirmatn', sans-serif",
				fontWeight: 'bold',
				textAlign: 'right',
				direction: 'rtl'
			},
			'.chakra-heading': {
				fontFamily: "'Vazirmatn', sans-serif",
				fontWeight: 'bold',
				textAlign: 'right',
				direction: 'rtl'
			},
			'input, textarea, select': {
				textAlign: 'right'
			},
			'.chakra-input, .chakra-textarea, .chakra-select': {
				textAlign: 'right'
			},
			'.chakra-modal__content': {
				direction: 'rtl'
			},
			'.chakra-toast': {
				direction: 'rtl',
				textAlign: 'right'
			}
		})
	}
};
